import React, { useState } from 'react';
import { Button, Modal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { IVeiculoDetalhes } from '../../store/ducks/agendamentos/types';
import TextTable from '../TextTable';
import { Container, Label } from './styles';
import TitlePage from '../TitlePage';

interface IModalDetalhesVeiculo {
  veiculo: IVeiculoDetalhes;
}

const ModalDetalhesVeiculo: React.FC<IModalDetalhesVeiculo> = ({ children, veiculo }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  return (
    <>
      <Modal
        centered
        title={<TitlePage>Dados do Veículo: {veiculo?.placa?.toUpperCase()}</TitlePage>}
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        maskClosable={true}
        closable={true}
        destroyOnClose={true}
        closeIcon={<CloseOutlined />}
        keyboard={true}
        width={750}
        footer={[
          <Button key="back" size="middle" onClick={() => setIsModalVisible(false)}>
            Fechar
          </Button>,
        ]}
      >
        <Container>
          <div>
            <p>
              <Label>Placa:</Label> <TextTable> {veiculo?.placa?.toUpperCase()} </TextTable>
            </p>
            <p>
              <Label>Ano:</Label> <TextTable>{veiculo?.ano} </TextTable>
            </p>
          </div>
          <div>
            <p>
              <Label>Carroceria:</Label> <TextTable>{veiculo?.tipoCarroceria} </TextTable>
            </p>
          </div>
        </Container>
      </Modal>

      <Button style={{ padding: 0 }} type="link" onClick={() => showModal()}>
        {children}
      </Button>
    </>
  );
};

export default ModalDetalhesVeiculo;
